module.exports = __webpack_public_path__ + "static/Millimetre-Regular_web-616dcd56ed06de1b615da382b49fe216.woff2";